export default __webpack_public_path__ + "static/media/facebook.192ad7fd.svg";